export const required = v => !!v || "Required";

export const minLength = length => {
  return v => (v && v.length >= length) || `Min ${length} characters`;
};

export const maxLength = length => {
  return v => {
    if (!v || v.length === 0) {
      return true;
    }
    return (v && v.length <= length) || `Max ${length} characters`;
  };
};

export const minNum = num => {
  return v => num <= v || `Min value: ${num}`;
};

export const atLeastOne = val => {
  return (val && val.length) || "You must select at least one";
};

export const maxNum = num => {
  return v => num >= v || `Max value: ${num}`;
};

export const betweenNums = (low, high) => {
  return v => (low <= v && high >= v) || `Must be between: ${low} and ${high}`;
};

export const email = v => {
  if (v.length === 0) {
    return true;
  }
  return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(v) || "Email must be valid";
};

export const username = v => {
  if (!v || v.length === 0) {
    return true;
  }
  return (
    /^(?=.*[a-zA-Z])[a-zA-Z0-9._@-]+$/.test(v) ||
    "Username must include at least one letter and can contain letters, numbers, and . _ @ - (no spaces)"
  );
};

export const trim = text => {
  return v => v.trim().length !== 0 || `Please enter a valid ${text}`;
};

const weakPasswords = [
  "password",
  "123456",
  "12345678",
  "qwerty",
  "abc123",
  "111111",
  "password1",
  "admin",
  "letmein"
];

export const password = v => {
  if (!v || v.length === 0) return "Password is required";

  // Minimum length
  if (v.length < 8) return "Password must be at least 8 characters";

  // Uppercase letter
  if (!/[A-Z]/.test(v))
    return "Password must include at least one uppercase letter (A–Z)";

  // Lowercase letter
  if (!/[a-z]/.test(v))
    return "Password must include at least one lowercase letter (a–z)";

  // Number
  if (!/[0-9]/.test(v))
    return "Password must include at least one number (0–9)";

  // ✅ ANY special character
  if (!/[^a-zA-Z0-9]/.test(v))
    return "Password must include at least one special character";

  // Weak passwords
  if (weakPasswords.includes(v.toLowerCase()))
    return "This password is too common. Please choose a stronger one";

  return true;
};

export const alphanumeric = v =>
  /^[a-z\d\s]+$/i.test(v) || "Must be alphanumeric";

export const numeric = v =>
  !v || v.length === 0 || /^(0|[1-9][0-9]*)$/.test(v) || "Must be numeric";

export const alphabetic = v =>
  !v || v.length === 0 || /^[a-zA-Z\s]*$/g.test(v) || "Must be only letters";

export default {
  required,
  minLength,
  maxLength,
  minNum,
  maxNum,
  betweenNums,
  email,
  password,
  alphanumeric,
  numeric,
  alphabetic,
  trim,
  username,
  atLeastOne
};
